import React, { Component } from "react";
import "../../Timps/style/style.css";
import _ from "lodash";
import { septaTurnoutInspectionFormInstructions } from "./instructionList";
import "./style.css";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";

const RenderListContainer = ({ list, type, className, children }) => {
  className = className ? className : "";
  if (list === "ol")
    return (
      <ol className={className} type={type}>
        {children}
      </ol>
    );
  else if (list === "ul") return <ul className={className}>{children}</ul>;
  else return <div className={className}>{children}</div>;
};

const RenderItemsList = ({ items }) => {
  return items.map((item) => {
    return (
      <li>
        {Array.isArray(item.title) ? (
          <div className={"_title"}>
            {item.title.map((t) => (
              <div>{t}</div>
            ))}
          </div>
        ) : (
          <div className={"_title"}>{item.title}</div>
        )}
        {item.data ? <div className={"_data"}>{item.data}</div> : null}
        {item.list ? (
          <RenderListContainer list={item.list} type={item.type} className={item.className}>
            <RenderItemsList items={item.items} />
          </RenderListContainer>
        ) : null}
      </li>
    );
  });
};

const SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportInstructions = () => {
  const { items, type, list, className } = septaTurnoutInspectionFormInstructions;
  return (
    <React.Fragment>
      <div className="avoid-break-in-printing">
        <ReportTitleSection title="STD TURNOUT INSPECTION FORM INSTRUCTIONS" hideLogo={true} />
        <div style={{ fontSize: "14px", columnWidth: "400px" }}>
          <RenderListContainer list={list} type={type} className={className}>
            <RenderItemsList items={items} />
          </RenderListContainer>
        </div>
      </div>
    </React.Fragment>
  );
};
export default SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionReportInstructions;



// WEBPACK FOOTER //
// ./src/components/Reports/SEPTA/TrackSectionTurnoutAndSpecialWorkInspectionForm/instructions.jsx